import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme.semantic";
import { withExtendedClass } from "../../../utils/utilities.style";

const Dropdown = styled.div.attrs(({ className }) =>
  withExtendedClass({
    className,
    extend: "dropdown"
  })
)`
  width: ${props => props.width};
  display: ${props => props.display};
  position: relative;
  padding-bottom: ${props => props.paddingBottom};
  .dropdown-content {
    padding: ${props => props.padding};
    display: none;
    position: absolute;
    background-color: ${props => props.backgroundColor};
    box-shadow: ${props => props.boxShadow};
    -moz-box-shadow: ${props => props.boxShadow};
    -webkit-box-shadow: ${props => props.boxShadow};
    -o-box-shadow: ${props => props.boxShadow};
    min-width: ${props => props.minContentWidth};
    z-index: 99;
    right: ${props => props.right};
    margin-top: ${props => props.marginTop};
  }

  :hover {
    .dropdown-content {
      display: block;
    }
  }

  :focus-within {
    .dropdown-content {
      display: block;
    }
  }

  //Underline animation on hover menu links
  ${props =>
    props.withUnderlineAnimation &&
    `
    :hover {
      :after {
        background-color: #fff;
        width: 30px;
      }
    }
    :focus-within {
      :after {
        background-color: #fff;
        width: 30px;
      }
    }
    :after {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 3px;
      background-color: transparent;
      margin-top: 5px;
      transition: width 0.4s ease;
      -webkit-transition: width 0.4s ease;
    }
  `};
`;

Dropdown.defaultProps = {
  padding: `${theme.spacing.m} 0`,
  backgroundColor: theme.components.dropDown.backgroundColor,
  boxShadow: theme.shadows.base,
  minContentWidth: theme.components.dropDown.minWidth,
  width: "100%",
  display: "inline"
};

Dropdown.propTypes = {
  padding: PropTypes.string,
  backgroundColor: PropTypes.string,
  boxShadow: PropTypes.string,
  minContentWidth: PropTypes.string,
  width: PropTypes.string,
  display: PropTypes.string,
  className: PropTypes.string,
  withUnderlineAnimation: PropTypes.bool
};

export default Dropdown;
